import { render, staticRenderFns } from "./PiutangPayments.vue?vue&type=template&id=73e82c30"
import script from "./PiutangPayments.vue?vue&type=script&lang=js"
export * from "./PiutangPayments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports